export default __webpack_public_path__ + "static/media/featured_area_barrie.c05efc04.webp";